/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { S as Sizes } from './constants-c94b83bd.js';

const DHL_TEXT_FONT_STYLES = {
    NORMAL: "normal",
    ITALIC: "italic",
};
const DHL_TEXT_SIZES = {
    "2XS": Sizes["2XS"],
    "XS": Sizes.XS,
    "SM": Sizes.SM,
    "MD": Sizes.MD,
    "LG": Sizes.LG,
    "XL": Sizes.XL,
    "2XL": Sizes["2XL"],
    "3XL": Sizes["3XL"],
    "4XL": Sizes["4XL"],
    "5XL": Sizes["5XL"],
    "6XL": Sizes["6XL"],
    "7XL": Sizes["7XL"],
    "8XL": Sizes["8XL"],
    "9XL": Sizes["9XL"],
    "10XL": Sizes["10XL"],
    "11XL": Sizes["11XL"],
};
const DHL_TEXT_STRETCH = {
    NORMAL: "normal",
    CONDENSED: "condensed",
};
const DHL_TEXT_WEIGHTS = {
    200: 200,
    400: 400,
    700: 700,
    800: 800,
};
const DHL_TEXT = {
    FONT_STYLE: DHL_TEXT_FONT_STYLES,
    SIZE: DHL_TEXT_SIZES,
    STRETCH: DHL_TEXT_STRETCH,
    WEIGHT: DHL_TEXT_WEIGHTS,
};

export { DHL_TEXT as D };

//# sourceMappingURL=constants-b27a9bbb.js.map